import * as React from 'react';
import cx from 'classnames';

import '../../resources/prism-shades-of-purple.css';

interface Props {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'base';
}

function CodeBlock({ children, className, size = 'base' }: Props) {
  const style: React.CSSProperties = {};

  if (size === 'sm') {
    style.padding = '1rem';
  }

  // Ensure a lanuage type is always present
  let extendedClassName = className;
  if (!className?.includes('language-')) {
    extendedClassName = cx(className, 'language-text');
  }

  return (
    <pre className={cx(extendedClassName, 'mb-4 rounded-lg shadow-lg')} style={style}>
      {children}
    </pre>
  );
}

export default CodeBlock;
